import _ from 'lodash'

const isLoading = (state) => _.get(state, 'loading')
const forumCategories = (state) => _.get(state, 'categories')

const chosenCategory = (state) => _.get(state, 'chosenCategory')
const forums = (state) => _.get(state, 'forums')
const forum = (state) => _.get(state, 'forum')
const pageForumCategories = (state) => _.get(state, 'pageCount.forumCategories')
const pageForums = (state) => _.get(state, 'pageCount.forums')
const comments = (state) => _.get(state, 'comments')
const isForumCommentAdding = (state) => _.get(state, 'commentAdding')
const forumBeingEdited = (state) => _.get(state, 'forumBeingEdited')

export default {
	isLoading,
	forumCategories,
	pageForumCategories,
	pageForums,
	forums,
	forum,
	comments,
	chosenCategory,
	isForumCommentAdding,
	forumBeingEdited
}
